import Conflicts from './Conflicts'
export default Conflicts
